import { Generic } from './Separator';
export function isSeparator(node) {
    return node !== null && typeof node === 'object' && node instanceof Generic;
}
export default isSeparator;    //# sourceMappingURL=isSeparator.js.map
